import { render, staticRenderFns } from "./SchoolYearPicker.vue?vue&type=template&id=3e2af121"
import script from "./SchoolYearPicker.vue?vue&type=script&lang=js"
export * from "./SchoolYearPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports